import { Injectable } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse } from './currencies.entity';

@Injectable({
  providedIn: 'root'
})
export class CurrenciesService extends AbstractService {
  constructor() {
    super();
    this.prefix = environment.cdnPath.replace(/\/$/, '');
  }

  getRates(): Observable<ApiResponse.RatesList> {
    return this.get<ApiResponse.RatesList>('/currencies/rates.json');
  }
}